import "./NursingCareProviderInBeershevaWithinHours.module.css";
import Header from "@/reusable_sections/Header";
import PortfolioHero from "./sections/PortfolioHero";
import OurMission from "./sections/OurMission";
import OurBirdRemovalServices from "./sections/OurBirdRemovalServices";
import FaqAccordionCoachingValue from "./sections/FaqAccordionCoachingValue";
import FinalCta from "./sections/FinalCta";
import Footer from "@/reusable_sections/Footer";
export default function NursingCareProviderInBeershevaWithinHoursPage() {
  return <div>
      <Header />
      <PortfolioHero />
      <OurMission />
      <OurBirdRemovalServices />
      <FaqAccordionCoachingValue />
      <FinalCta />
      <Footer />
    </div>;
}